import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Scale,
  ClipboardList,
  FileText,
  CreditCard,
  Star,
  Settings,
  ScrollText,
} from 'lucide-react';
import { Header } from './Header';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const adminNav = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/admin/usuarios', label: 'Usuários', icon: Users },
  { to: '/admin/advogados', label: 'Advogados', icon: Scale },
  { to: '/admin/tarefas', label: 'Tarefas', icon: ClipboardList },
  { to: '/admin/contratos', label: 'Contratos', icon: FileText },
  { to: '/admin/pagamentos', label: 'Pagamentos', icon: CreditCard },
  { to: '/admin/avaliacoes', label: 'Avaliações', icon: Star },
  { to: '/admin/audit-log', label: 'Audit log', icon: ScrollText },
  { to: '/admin/configuracoes', label: 'Configurações', icon: Settings },
];

export function AdminShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <div className="flex flex-1">
        <aside className="hidden lg:flex w-64 flex-col border-r border-border/60 bg-surface px-4 py-8 gap-1">
          <div className="px-3 mb-4">
            <Badge variant="accent" className="gap-1">
              <Scale className="h-3 w-3" />
              Backoffice
            </Badge>
          </div>
          {adminNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end ?? false}
              className={({ isActive }) =>
                cn(
                  'inline-flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors',
                  isActive
                    ? 'bg-muted/60 text-foreground font-medium'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted/40',
                )
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </aside>
        <main className="flex-1 px-6 py-8 lg:px-12 bg-background">{children}</main>
      </div>
    </div>
  );
}
